import loadable from "@loadable/component";
import { useNavigate, useParams } from "react-router";
import Spinner from "../../components/Reusable/Spinner";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useState } from "react";
import { toast } from "react-toastify";
import { patchApiFormData } from "../../helpers/AxiosInstance";
import { queryClient } from "../../router";
import usePatchHook from "../../customHooks/usePatchHook";
const EditBranchComponent = loadable(
  () => import("../../components/Branch/Switchtab")
);

const EditBranch = () => {
  const { id } = useParams();

  const { data: branchData, isLoading } = useGetHook({
    queryKey: ["branch", `branch-${id}`],
    url: `${APIS.BRANCH}${id}/`,
    params: {},
  });

  const { data: bankData, isLoading: isBankDataLoading } = useGetHook({
    queryKey: ["bank-details", `bank-${id}`],
    url: `${APIS.BANK_DETAIL}`,
    params: {
      object_id: id,
    },
  });
  const { mutateAsync: patchUser } = usePatchHook({
    queryKey: ["branch"],
    navigateURL: null,
  });
  const navigate = useNavigate();
  const [isPatchLoading, setIsLoading] = useState(false);

  const handleEdit = async (values: any, setError: any) => {
    setIsLoading(true);
    const url = `${APIS.BRANCH}${id}/`;
    const formData = new FormData();
    formData.append("name", values?.name);
    formData.append("code", values?.code);
    formData.append("company_name", values?.company_name);
    formData.append("primary_email", values?.primary_email);
    formData.append("vat_pan", values?.vat_pan);
    formData.append("landmark", values?.landmark);
    formData.append("manager", values?.manager);
    formData.append("primary_contact", values?.primary_contact);
    formData.append("secondary_contact", values?.secondary_contact);
    values?.warehouse ? formData.append("warehouse", values?.warehouse) : null;
    values?.default_rate_template
      ? formData.append("default_rate_template", values?.default_rate_template)
      : null;
    formData.append("charge_type", values?.charge_type);
    formData.append("charge", values?.charge);
    formData.append("transit_charge", values?.transit_charge);
    formData.append("is_franchise", values?.is_franchise);
    if (values?.logo && values.logo instanceof File) {
      formData.append("logo", values.logo);
    }
    values?.covered_city && values?.covered_city?.length > 0
      ? values?.covered_city?.map((item: any) =>
          formData.append("covered_city", item?.value)
        )
      : null;
    values?.service_branch && values?.service_branch?.length > 0
      ? values?.service_branch?.map((item: any) =>
          formData.append("service_branch", item?.value)
        )
      : null;
    try {
      const res = await patchApiFormData({ url, formData, setError });
      if (res?.status === 200) {
        queryClient.refetchQueries();
        toast.success("Updated Successfully");
        navigate("/");
      } else {
        toast.error(res?.data?.message ?? "Something Went Wrong");
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleIsEnableSMS = async (value: boolean, id: any) => {
    const payload = {
      is_enable_sms: value,
    };
    const url = `${APIS.BRANCH}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  const handleIsEnableEmail = async (value: boolean, id: any) => {
    const payload = {
      is_enable_email: value,
    };
    const url = `${APIS.BRANCH}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  const handleIsActive = async (value: boolean, id: any) => {
    const payload = {
      is_active: value,
    };
    const url = `${APIS.BRANCH}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Branch
        </span>
      </div>
      {isLoading || isBankDataLoading ? (
        <Spinner />
      ) : (
        <EditBranchComponent
          id={id}
          isLoading={isPatchLoading}
          handleEdit={handleEdit}
          branchData={branchData}
          bankData={bankData}
          handleIsEnableSMS={handleIsEnableSMS}
          handleIsEnableEmail={handleIsEnableEmail}
          handleIsActive={handleIsActive}
        />
      )}
    </>
  );
};
export default EditBranch;
